import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const enemyCorpseEntries: RawTilesetEntry[] = [
	{
		key: "SquidCorpse",
		sprites: ["SquidCorpse1.png", "SquidCorpse2.png"],
	},
	{
		key: "AlbinoSquidCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "AlbinoSquidCorpse_0.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "AlbinoSquidCorpse_0.png", interval: 0 }],
			},
			{
				loop: true,
				frames: [{ filename: "AlbinoSquidCorpse_1.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "AlbinoSquidCorpse_1.png", interval: 0 }],
			},
		],
	},
	{
		key: "ScrapMetal",
		sprites: ["ScrapMetal1.png", "ScrapMetal2.png"],
	},
	{
		key: "HornedCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "HornedMobCorpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "HornedMobCorpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "BiterCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "BiterB_Corpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "BiterB_Corpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "AmoebaCorpse",
		sprite: "AmoebaCorpse.png",
	},
	{
		key: "SlugantCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "SlugantCorpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "SlugantCorpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "RobotCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "Robot5_Corpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "Robot5_Corpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "CaveRobotCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "CaveRobot_Corpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "CaveRobot_Corpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "FloatingRobotCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "Robot7_Corpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "Robot7_Corpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "EngineerCorpse",
		animations: [
			{
				loop: true,
				frames: [{ filename: "Engineer_Corpse.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "Engineer_Corpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "DummyMobCorpse",
		sprite: "DummyMobCorpse.png",
	},
];
